import { Team, TestIdProvider } from '@ori/testid-generator';
import { SWRConfig } from 'swr';
import Account from '../components/Account/Account';
import { APPLICATION_NAME, swrConfig } from '../constants';
import { ConfigurationProvider } from '../contexts/ConfigurationContext';
import { NavigationContextProvider } from '../contexts/NavigationContext';
import { SocialMediaContextProvider } from '../contexts/SocialMediaContext';
import { UserCredentialsContextProvider } from '../contexts/UserCredentialsContext';
import { I18nContainer } from './I18nContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export var LoginSidebar = function LoginSidebar(config) {
  return /*#__PURE__*/_jsx(ConfigurationProvider, {
    initial: config,
    children: /*#__PURE__*/_jsx(SWRConfig, {
      value: swrConfig,
      children: /*#__PURE__*/_jsx(TestIdProvider, {
        team: Team.Acquisition,
        project: APPLICATION_NAME,
        children: /*#__PURE__*/_jsx(NavigationContextProvider, {
          children: /*#__PURE__*/_jsx(SocialMediaContextProvider, {
            children: /*#__PURE__*/_jsx(UserCredentialsContextProvider, {
              children: /*#__PURE__*/_jsx(I18nContainer, {
                children: /*#__PURE__*/_jsx(Account, {})
              })
            })
          })
        })
      })
    })
  });
};